<div class="row justify-content-center p-5" *ngIf="caseloading || loadingCache">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
  </div>
</div>
<div class="row" *ngIf="page === 'create' && !caseloading && !loadingCache">
  <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 p-3">
    <form>

      <!-- type -->
      <div class="field">
        <label for="type">{{ 'pages.support.dashboard.fieldTitles.type' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logtypeDesc' | translate }}"></fa-icon></label>
        <select class="form-select" name="type" aria-describedby="type" [(ngModel)]="case.type"
          [ngClass]="{'has-danger': !case.type}">
          <option></option>
          <option value="{{tt}}" *ngFor="let tt of caseTypeCV" title="{{ caseTypeCvI18n[tt] | translate | stripHtml}}">
            {{tt}}</option>
        </select>
      </div>

      <!-- subject -->
      <div class="field">
        <label for="subject">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logSubjDesc' | translate }}"></fa-icon></label>
        <input type="text" class="form-control" name="subject" id="subject" aria-describedby="Subject"
          [(ngModel)]="case.subject" [ngClass]="{'has-danger': !case.subject}">
      </div>

      <!-- description -->
      <div class="field">
        <label for="exampleInputTicketRef">{{ 'pages.support.dashboard.fieldTitles.description' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logDescrDesc' | translate }}"></fa-icon></label>
        <textarea class="form-control" id="desc" rows="10" name="desc" [(ngModel)]="case.description"
          [ngClass]="{'has-danger': !case.description}"></textarea>
      </div>

      <!-- incident -->
      <div class="field" *ngIf="case.type === 'Incident'">
        <label for="priority">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logPriorityDesc' | translate }}"></fa-icon></label>
        <select class="form-control" name="priority" aria-describedby="priority" [(ngModel)]="case.priority"
          [ngClass]="{'has-danger': !case.priority}">
          <option></option>
          <option value="{{tt}}" *ngFor="let tt of casePriorityCV">{{tt}}</option>
        </select>
        <div class="alert alert-danger mt-2" role="alert" *ngIf="case.priority === '1 - Business Critical'">
          <span class="alert-icon"><span class="visually-hidden"></span></span>
          <p>{{ 'pages.support.dashboard.fieldTitles.priorityOneError' | translate }}
            <br><br>
            <span class='ms-3' *ngFor="let contact of priorityOneErrorContacts">{{contact}}<br></span>
          </p>
        </div>
      </div>

      <!-- change type-->
      <div class="field" *ngIf="case.type === 'Change Request'">
        <label for="changeType">{{ 'pages.support.dashboard.fieldTitles.changeType' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.changeTypeDesc' | translate }}"></fa-icon></label>
        <select class="form-control" name="changeType" aria-describedby="changeType" [(ngModel)]="case.changeType"
          [ngClass]="{'has-danger': !case.changeType}">
          <option title="{{ 'pages.support.log.changeStandDesc' | translate }}" selected value="Standard Change">{{
            'pages.support.log.standardChange' | translate }}</option>
          <option selected value="Normal Change">{{ 'pages.support.log.normalChange' | translate }}</option>
          <option title="{{ 'pages.support.log.changeEmergDesc' | translate }}" value="Emergency Change">{{
            'pages.support.log.emergencyChange' | translate }}</option>
        </select>
        <div class="alert alert-danger mt-2" role="alert" *ngIf="case.changeType === 'Emergency Change'">
          <span class="alert-icon"><span class="visually-hidden"></span></span>
          <p>{{ 'pages.support.dashboard.fieldTitles.priorityOneError' | translate }}
            <br><br>
            <span class='ms-3' *ngFor="let contact of priorityOneErrorContacts">{{contact}}<br></span>
          </p>
        </div>
      </div>

      <!-- preferred date -->
      <div class="field" *ngIf="case.type === 'Change Request' && case.changeType !== 'Emergency Change'">
        <div class="custom-control custom-switch float-start me-3" data-toggle="tooltip"
          data-placement="top" title="{{ 'pages.support.dashboard.enablePreferredDate' | translate }}">
          <input class="form-check-input" type="checkbox" id="showDateTime" [(ngModel)]="showDateTime"  [ngModelOptions]="{standalone: true}" (change)="setupDateTime()"/>
          <label for="dateTime">
            {{ 'pages.support.dashboard.fieldTitles.preferredDateTime' | translate }}
            <fa-icon [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip"
              data-placement="top"
              title="{{ 'pages.support.dashboard.fieldTitles.preferredDateTimeDesc' | translate }}"></fa-icon>
          </label>
        </div>
        <input [disabled]="!showDateTime" type="datetime-local" [min]="minDateAllowed" class="form-control" name="dateTime" aria-describedby="dateTime" [(ngModel)]="case.dateTime">
      </div>

      <!-- customer reference -->
      <div class="field">
        <label for="customerReference">{{ 'pages.support.dashboard.fieldTitles.customerReference' | translate }}
          <fa-icon [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip"
            data-placement="top" title="{{ 'pages.support.log.logRefDesc' | translate }}"></fa-icon></label>
        <input type="text" class="form-control" name="customerReference" id="customerReference"
          aria-describedby="customerReference" [(ngModel)]="case.customerReference" maxlength="50">
      </div>

      <div class="field">
        <label for="entitlement">{{ 'pages.support.dashboard.fieldTitles.service' | translate }}<fa-icon
          [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
          title="{{ 'pages.support.log.logServDesc' | translate }}"></fa-icon></label>

        <!-- service -->
        <div class="row ms-0 me-0">
          <span class="section col-12 p-3">
            <div class="row">
              <label for="asset">{{ 'pages.support.dashboard.fieldTitles.service' | translate }}</label>
            </div>
            <div class="row">

              <!-- select service -->
              <div class="col-6">
                <div class="d-flex custom-select" [ngClass]="{'has-danger': !isServiceNameValid()}">
                  <select class="form-select delete-opt" name="servicename" aria-describedby="servicename" [(ngModel)]="selectedService"
                      (change)="onSelectService()">
                      <option [ngValue]="defaultService"></option>
                      <option [ngValue]="service" *ngFor="let service of filteredService | filterPipe: serviceSearch">{{service.serviceName}}</option>
                    </select>
                    <!-- remove selected service -->
                    <button type="button" class="btn btn-icon delete" (click)="removeSelectedService()" [disabled]="!selectedService || selectedService.serviceName ==='default'">
                      <fa-icon
                        [icon]="['fas', 'times']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
                        title="{{ 'pages.support.log.logAssetDesc' | translate }}"></fa-icon>
                    </button>
                </div>
              </div>
              <span class="input-group-text col-1">&nbsp;</span>

              <!-- filter service -->
              <div class="col-5">
                <input type="search" class="form-control" placeholder="Filter service"
                  [(ngModel)]="serviceSearch" [ngModelOptions]="{standalone: true}" title="{{ 'pages.assets.dashboard.serviceSearch' | translate }}">
              </div>
            </div>
          </span>
        </div>
      </div>

      <!-- asset -->
      <div class="field">
        <label for="asset">{{ 'pages.support.dashboard.fieldTitles.asset' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logAssetDesc' | translate }}"></fa-icon></label>

        <!-- filter asset -->
        <app-asset-filter [(selectedService)]="selectedService" [(case)]="case" [(assets)]="filteredAssets" (assetSelected)="onAssetUpdate($event)"></app-asset-filter>
      </div>

      <!-- world watch base reference -->
      <div class="field" *ngIf="useWorldWatch">
        <label for="worldWatch">{{ 'pages.support.dashboard.fieldTitles.worldWatchReference' | translate }}<fa-icon
          [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
          title="{{ 'pages.support.log.worldWatchReferenceDesc' | translate }}"></fa-icon></label>
        <input
          type="text"
          placeholder={{worldWatchBaseRef}}
          class="form-control"
          name="worldWatchReference"
          id="worldWatchReference"
          aria-describedby="worldWatchReference"
          [value]="case.worldWatchReference"
          maxlength="50"
          disabled >
      </div>

      <!-- contact -->
      <div class="field pt-2">
        <label for="contact">{{ 'pages.support.dashboard.fieldTitles.contact' | translate }}<fa-icon
            [icon]="['fas', 'question-circle']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
            title="{{ 'pages.support.log.logContactDesc' | translate }}"></fa-icon></label>
        <select class="form-select" name="contact" aria-describedby="contact" [(ngModel)]="case.contactId"
          [ngClass]="{'has-danger': !case.contactId}">
          <option></option>
          <option value="{{tt.id}}" *ngFor="let tt of contacts">{{tt.fullName}}</option>
        </select>
      </div>

      <button type="button" data-testid="submit" (click)="submit();" disabled *ngIf="!submitValid()" 
        class="btn btn-primary float-end">{{ 'buttons.action.submit' | translate }}</button>
      <button type="button" data-testid="submit" (click)="submit();" *ngIf="submitValid()" class="btn btn-primary float-end">{{
        'buttons.action.submit' | translate }}</button>
    </form>
  </div>
  <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
</div>


<div class="row" *ngIf="page === 'submit'">
  <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 p-3">

    <div class="row justify-content-center" *ngIf="!saved">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
      </div>
    </div>

  </div>
  <div class="col-xl-1 d-none d-lg-block">&nbsp;</div>
</div>
